import { Component, signal } from '@angular/core';
import { SharedModule } from '../../shared-module';
import { I18nService } from '../../../core/services/i18n.service';
import { PlatformService } from '../../../core/services/platform.service';
import { StorageService } from '../../../core/services/storage.service';

@Component({
  selector: 'app-cookie-banner',
  imports: [SharedModule],
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.scss'
})
export class CookieBannerComponent {
  constructor(public storageService: StorageService, public i18nService: I18nService) { }

  ngOnInit() {

  }
  setOkey() {
    this.storageService.cookeyApprove.value = true;
  }
}
